module.exports = __webpack_public_path__ + "static/media/menu-img.51d17457.jpg";